import React, {useEffect, useState} from 'react'
import {useRequest} from "ahooks";
import {useFormikContext} from "formik";
import CanvasCreateEditButtons from "../../../UI/Canvas/CanvasCreateEditButtons";
import customerService from "../../../../../services/customerService";
import CustomerOffCanvas from "../../../../../pages/Production/SystemTables/Customers/CustomerOffCanvas";
import {FormSelect} from "../../FormSelect";
import {toast} from "react-toastify";

const CustomerPicker = ({name, onSelected, withCreate}) => {

    const {data, loading, runAsync} = useRequest(customerService.selectable);

    const [currentSelected, setCurrentSelected] = useState(undefined);
    const {values, setFieldValue} = useFormikContext()
    const [isCanvasOpen, setIsCanvasOpen] = useState(false);

    useEffect(() => {
        if (loading)
            return;

        if (values[name]) {
            const option = data.find(d => d.value === values[name])
            option
                ? customerService.fetch(option.uuid).then(res => setCurrentSelected(res))
                : setCurrentSelected(undefined)
        } else {
            setCurrentSelected(undefined)
        }

    }, [data, values[name]])

    const handleResponse = (value) => {
        runAsync().then(() => {
            onSelected({
                value: value.id,
                label: value.business_name
            })
            setIsCanvasOpen(false)
        })
    }

    const handleDelete = () => {
        customerService.destroy(currentSelected.uuid)
            .then(res => runAsync()
                .then(() => {
                    setFieldValue(name, undefined)
                    toast.success('Operazione eseguita con successo')
                })
            ).catch(err => toast.error(err.response.data.message))
    }


    return (
        <React.Fragment>

            <FormSelect
                name={name}
                onChange={(customer) => onSelected(data.find(d => d.value === customer))}
                loading={loading}
                placeholder="Seleziona un cliente"
                options={data}
                multiple={false}
            />

            {withCreate &&
                <>
                    <CanvasCreateEditButtons
                        value={values[name]}
                        canvasOpen={isCanvasOpen}
                        setCanvasOpen={setIsCanvasOpen}
                        handleDelete={handleDelete}
                    />


                    <CustomerOffCanvas
                        isOpen={isCanvasOpen}
                        toggle={setIsCanvasOpen}
                        data={currentSelected}
                        handleResponse={handleResponse}
                    />
                </>
            }

        </React.Fragment>
    )
}

export default CustomerPicker
